import VoucherForm from "../VoucherForm";

const CreateVoucher = () => <VoucherForm />;

export default CreateVoucher;
